<template>
<section>
    <h1>{{ t.albums }}</h1>
    <div class="profile-albums">
        <div v-if="owner" class="album-create" @click="showCreateModal">
            <i class="fa fa-plus site-bg"></i>
            <div>{{ t.create_album }}</div>
        </div>
        <div v-for="album in allAlbums" :key="album.id" :data-id="album.id" class="album" @click="clickAlbum(album)">
            <i v-if="album.private" class="fa fa-lock" :title="t.private_album"></i>
            <div v-if="owner && !album.system" class="btn-group">
                <button type="button" class="btn btn-default btn-xs" v-dropdown>
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                    <li><a href="#" @click.prevent="deleteAlbum(album)">{{ gt.common.delete }}</a></li>
                    <li v-if="!album.private"><a href="#" @click.prevent="setPrivacy(album, 1)">{{ t.make_private }}</a></li>
                    <li v-if="album.private"><a href="#" @click.prevent="setPrivacy(album, 0)">{{ t.make_public }}</a></li>
                </ul>
            </div>
            <img v-if="album.cover && album.cover.media['large-thumbnail'] && album.cover.media['large-thumbnail'].url"
                :src="album.cover.media['large-thumbnail'].url">
            <i v-else class="fa fa-camera"></i>
            <div>
                <span v-if="owner && !album.system" class="album-title">
                    <editable :params="{ id: album.id, url: 'album', private: album.private }" type="text" property="name"
                        :value="album.name" :inline="false"></editable>
                </span>
                <span v-else class="album-title">{{ album.name }}</span>
                <span class="count">{{ album.count }}</span>
            </div>
        </div>
    </div>
    <modal v-model="createModal.show" :title="t.create_album" :submit="t.create" @submit="createAlbum">
        <form class="form-horizontal" @submit="createAlbum">
            <div class="form-group">
                <label for="createAlbumName" class="col-sm-2 control-label">{{ t.name }}</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" id="createAlbumName" v-model="createModal.name" ref="createName">
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="createModal.private"> {{ t.private }}
                        </label>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</section>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import dropdownDirective from 'Site/directive/dropdown';
import Editable from 'Site/component/Editable.vue';
import Modal from 'Site/component/Modal.vue';
import { mapState } from 'vuex';

export default {
    name: 'ProfileMediaAlbums',
    components: {
        Editable,
        Modal
    },
    computed: mapState({
        gt: state => state.gt,
        notEmailVerified: state => state.config.data.verifyId !== null,
        t: state => state.t.profile_media
    }),
    directives: {
        dropdown: dropdownDirective
    },
    data() {
        return {
            allAlbums: this.albums,
            createModal: {
                name: '',
                private: false,
                show: false
            }
        };
    },
    methods: {
        clickAlbum(album) {
            this.$emit('change-album', album);
        },
        createAlbum() {
            if (!this.createModal.name) {
                return;
            }
            ajax.create('album', {
                name: this.createModal.name,
                private: this.createModal.private ? 1 : 0
            }).then((album) => {
                album.count = 0;
                album.allowed = true;
                album.collections = [];
                this.allAlbums.push(album);
                this.$emit('change-album', album);
                this.createModal.show = false;
                this.createModal.private = false;
                this.createModal.name = '';
            });
        },
        deleteAlbum(album) {
            const deleteFunction = () => {
                ajax.delete('album', { id: album.id });
                this.allAlbums = this.allAlbums.filter(checkAlbum => checkAlbum.id !== album.id);
            };
            this.$store.dispatch('showConfirm', {
                text: this.t.album_delete_confirm,
                callback: deleteFunction.bind(this)
            });
        },
        setPrivacy(album, privacy) {
            ajax.update('album', {
                id: album.id,
                name: album.name,
                private: privacy
            });
            album.private = !!privacy;
        },
        showCreateModal() {
            if (this.notEmailVerified) {
                this.$emit('email-verify');
                return;
            }
            this.createModal.show = true;
            this.$nextTick(() => {
                this.$refs.createName.focus();
            });
        }
    },
    props: {
        albums: {
            type: Array,
            required: true
        },
        owner: {
            type: Boolean,
            default: false
        }
    }
};

</script>

<style lang="scss">
@import "~Site/scss/variables";
.profile-albums, .album-invites {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    text-align: center;
    clear: both;
    .count {
        line-height: 14px;
    }
    .album-title {
        @include text-overflow();
        max-width: 98px;
    }
    .album, .album-create {
        float: left;
        margin-right: 10px;
        position: relative;
        cursor: pointer;
        @include card;

        &:hover {
            opacity: 0.8;
        }

        a:hover {
            text-decoration: none;
        }

        .fa-lock {
            position: absolute;
            z-index: 2;
            left: 10px;
            top: 8px;
            color: #666;
            font-size: 1.5em;
        }
        .fa-camera, .fa-plus {
            height: 150px;
            width: 150px;
            text-align: center;
            font-size: 6em;
            color: #e6e6e6;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .fa-plus {
            color: #fff;
        }

        img {
            height: 150px;
            width: 150px;
        }
        div {
            padding: 10px;
            display: flex;
            justify-content: center;
        }
    }
    .album .btn-group {
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 0;
        ul {
            right: 0;
            left: auto;
        }
    }
    // Hides media item when dragged into an album
    .album .media-item {
        display: none;
    }
    .count {
        height: 18px;
    }
    .sh-editable {
        input {
            margin-bottom: 40px;
        }
        span button {
            position: absolute;
            bottom: 10px;
        }
        span .btn-default {
            right: 10px;
        }
        span .btn-primary {
            left: 10px;
        }
    }
}
.album-invites .album {
    cursor: default;
    div + div {
        padding-top: 0;
    }
}
@media (max-width: $screen-xs-max) {
    .profile-albums, .album-invites {
        .album, .album-create {
            margin-right: 5px;
        }
        .album .fa-camera, .album img, .album-create .fa-plus {
            height: 140px;
            width: 140px;
        }
    }
}
</style>
